import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { fetchUser, updateUser } from "../../actions/user";
import PhoneInput from "react-phone-number-input";
import DatePicker from "react-datepicker";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import { Loader } from "../../components/loader";
import classnames from "classnames";
import AvatarEditor from "react-avatar-editor";
import Slider from "react-rangeslider";
import "react-rangeslider/lib/index.css";
import "react-phone-number-input/style.css";

import { attachAvatar } from "../../actions/user";
import { BreadCrumb } from "../../components/breadcrumb";

const AWS = require("aws-sdk");

const toCapitalize = (name) => {
  if (name && name.length > 1) {
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  }
}
class Profile extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    user: { UserPetstores: [{ Role: {} }], PetShop: {} },
    edit: false,
    loading: false,
    changeAvatar: false,
    imgSrc: null,
    imgName: null,
    zoom: 1.5,
    editor: "",
    cPassword: false,
    items: [],
    role: ""
  };
  componentDidMount = () => {
    this.props.fetchUser(this.props.match.params.id);
  };

  componentWillReceiveProps = nextProps => {
    if (this.props.match.params.id !== nextProps.match.params.id) {
      this.props.fetchUser(nextProps.match.params.id);
    }
    if (this.props.data.selectedUser !== nextProps.data.selectedUser) {
      this.setState({ user: nextProps.data.selectedUser });

      if (
        nextProps.data.selectedUser.UserPetstores[0].Role.role_name === "Admin"
      ) {
        const itemTemp = [
          { title: "Settings", to: "/settings" },
          { title: "Profile", to: "/users/" + this.props.match.params.id }
        ];
        this.setState({ items: itemTemp });
      } else {
        const itemTemp = [
          { title: "Profile", to: "/users/" + this.props.match.params.id }
        ];
        this.setState({ items: itemTemp });
      }
    }

    if (this.props.data.updatedUser !== nextProps.data.updatedUser) {
      this.setState({ loading: false, edit: false });
      this.props.fetchUser(this.props.match.params.id);
      NotificationManager.success("User Updated Successfully");
    }

    if (this.props.data.newAvatar !== nextProps.data.newAvatar) {
      this.setState({ changeAvatar: false });
      this.props.fetchUser(this.props.match.params.id);
      NotificationManager.success("Avatar Updated Successfully");
    }
  };

  componentDidUpdate(prevProps, prevState) {
    // Typical usage (don't forget to compare props):
  }

  setEditorRef = editor => {
    if (editor) {
      this.setState({ editor: editor });
    }
  };

  changeVal = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  changeDate = value => {
    this.setState({ birthday: value });
  };

  cancelEdit = () => {
    this.setState({ edit: false });
  };

  cancelCPassword = () => {
    this.setState({
      edit: false,
      cPassword: false,
      currentPw: "",
      newPw: "",
      retypePw: ""
    });
  };

  changeAvatar = () => {
    this.setState({ changeAvatar: true });
  };

  editUser = () => {
    this.setState({
      cPassword: false,
      edit: true,
      gender: this.state.user.UserPetstores[0].gender,
      birthday: moment(this.state.user.UserPetstores[0].birthday).toDate(),
      contact_no: this.state.user.UserPetstores[0].contact_no,
      firstname: this.state.user.UserPetstores[0].firstname,
      lastname: this.state.user.UserPetstores[0].lastname,
      employee_id: this.state.user.UserPetstores[0].employee_id,
      role: this.state.user.UserPetstores[0].Role.role_name
    });
  };

  changeZoom = val => {
    if (val) {
      this.setState({ zoom: val });
    }
  };

  _onChange = () => {
    // Assuming only image
    var file = this.refs.file.files[0];
    var reader = new FileReader();
    var url = reader.readAsDataURL(file);

    reader.onloadend = function(e) {
      this.setState({
        imgSrc: reader.result,
        imgName: file.name
      });
    }.bind(this);
    // TODO: concat files
  };

  saveUser = event => {
    event.preventDefault();
    this.setState({ loading: true });
    const data = {
      PetShopId: this.props.petShop.currentPetshop.id,
      gender: this.state.gender,
      birthday: moment(this.state.birthday),
      contact_no: this.state.contact_no,
      firstname: this.state.firstname,
      lastname: this.state.lastname,
      employee_id: this.state.employee_id,
      role: this.state.role
    };

    if (
      data.gender &&
      data.birthday &&
      data.contact_no &&
      data.firstname &&
      data.employee_id &&
      data.role
    ) {
      this.props.updateUser(this.state.user.id, data);
    } else {
      NotificationManager.warning("Incomplete information.");
      this.setState({ loading: false });
    }
  };

  saveAvatar = () => {
    var image = "";

    if (this.state.editor && this.state.imgSrc) {
      image = this.state.editor
        .getImageScaledToCanvas()
        .toDataURL("image/jpeg");
    }

    var data = {
      avatar: image
    };

    this.props.attachAvatar(this.props.match.params.id, data);
  };

  saveCPassword = event => {
    event.preventDefault();
    this.setState({ loading: true });

    const awsS3Config = {
      accessKeyId: this.props.config.S3_ACCESS_KEY_ID,
      secretAccessKey: this.props.config.S3_SECRET_ACCESS_KEY,
      region: this.props.config.region
    };
    var cognitoIdentityService = AWS.CognitoIdentityServiceProvider;
    var client = new cognitoIdentityService(awsS3Config);

    var params = {
      AccessToken: this.getToken() /* required */,
      PreviousPassword: this.state.currentPw /* required */,
      ProposedPassword: this.state.newPw /* required */
    };

    client.changePassword(
      params,
      function(err, data) {
        if (err) {
          if(err)
            NotificationManager.error(err.message);
          this.setState({
            loading: false,
            newPw: "",
            retypePw: "",
            currentPw: ""
          });
        } else {
          NotificationManager.success("Password updated successfully");
          this.setState({ loading: false });
          this.cancelCPassword();
        } // successful response
      }.bind(this)
    );
  };

  changePassword = () => {
    this.setState({ cPassword: true, edit: false });
  };

  getToken() {
    let username = this.props.user.username;
    let clientId = this.props.user.pool.clientId;
    let token = this.props.user.storage[
      "CognitoIdentityServiceProvider." +
        clientId +
        "." +
        username +
        ".accessToken"
    ];
    return token;
  }

  render() {
    const {
      user,
      edit,
      gender,
      birthday,
      contact_no,
      firstname,
      lastname,
      employee_id,
      role,
      cPassword,
      newPw,
      currentPw,
      retypePw
    } = this.state;
    const { country } = this.props.petShop.currentPetshop;
    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <BreadCrumb items={this.state.items} />
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="col-xl-4 col-md-6 col-sm-12 mx-auto my-0">
                <div className="m-portlet m-portlet--full-height">
                  <div className="m-portlet__head">
                    <div className="m-portlet__head-caption">
                      <div className="m-portlet__head-title">
                        <h3 className="m-portlet__head-text mr-2">
                          {" "}
                          {!edit
                            ? user.UserPetstores[0].firstname
                            : firstname}{" "}
                          {!edit ? user.UserPetstores[0].lastname : lastname}
                        </h3>
                        <span className="m-badge m-badge--info px-2">
                          Emp no.{" "}
                          <strong>
                            {!edit
                              ? user.UserPetstores[0].employee_id
                              : employee_id}
                          </strong>
                        </span>
                      </div>
                      <div className="m-portlet__head-tools">
                        {/* {!edit &&
                            <a onClick={() => this.editUser()} className="btn btn-warning m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill mx-2">
                                <span>
                                    <i className="fas fa-edit"></i>
                                    <span>
                                        Edit
                                    </span>
                                </span>
                            </a>
                        } */}
                        <ul className="m-portlet__nav">
                          <li className="m-portlet__nav-item">
                            <button
                              type="button"
                              onClick={() => this.editUser()}
                              className="btn btn-link btn-link-no-deco m-portlet__nav-link m-portlet__nav-link--icon"
                              style={{ width: "unset" }}
                            >
                              <i className="la la-edit"></i>
                            </button>
                          </li>
                          {this.props.data.currentUser &&
                            this.props.data.selectedUser &&
                            this.props.data.currentUser.id ===
                              this.props.data.selectedUser.id && (
                              <li className="m-portlet__nav-item">
                                <button
                                  type="button"
                                  onClick={() => this.changePassword()}
                                  className="btn btn-link btn-link-no-deco m-portlet__nav-link m-portlet__nav-link--icon"
                                  style={{ width: "unset" }}
                                >
                                  <i className="la la-key"></i>
                                </button>
                              </li>
                            )}
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="m-portlet__body">
                    <div className="m-widget4">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="row m--align-center">
                            <div
                              className={classnames({
                                "m-widget4__img m-widget4__img--pic my-0": true,
                                "user-avatar mx-auto": !this.state.imgSrc,
                                "m-width-100-perc": this.state.imgSrc
                              })}
                            >
                              {this.state.imgSrc && this.state.changeAvatar ? (
                                <div className="form-group m-form__group row justify-content-md-center m--align-center">
                                  <div className="col-xs-10 col-md-6">
                                    <AvatarEditor
                                      ref={this.setEditorRef}
                                      image={this.state.imgSrc}
                                      border={0}
                                      width={200}
                                      height={200}
                                      borderRadius={100}
                                      color={[0, 0, 0, 0.6]} // RGBA
                                      scale={this.state.zoom}
                                      rotate={0}
                                    />
                                  </div>
                                  <div className="col-xs-2 col-md-4 d-none d-sm-none d-md-block">
                                    <div className="slider orientation-reversed">
                                      <div className="slider-group">
                                        <div className="slider-vertical">
                                          <Slider
                                            min={1}
                                            max={5}
                                            step={0.1}
                                            tooltip={false}
                                            value={this.state.zoom}
                                            orientation="vertical"
                                            onChange={this.changeZoom}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xs-2 col-md-4 d-block d-sm-block d-md-none d-lg-none">
                                    {/* <div className='slider orientation-reversed'>
                                    <div className='slider-group'>
                                        <div className='slider-vertical'> */}
                                    <Slider
                                      min={1}
                                      max={5}
                                      step={0.1}
                                      tooltip={false}
                                      value={this.state.zoom}
                                      onChange={this.changeZoom}
                                    />
                                    {/* </div>
                                                                            </div>
                                                                        </div> */}
                                  </div>
                                </div>
                              ) : user.UserPetstores[0].avatar_file_name ? (
                                <img
                                  src={
                                    process.env.REACT_APP_S3_PATH +
                                    "/" +
                                    user.UserPetstores[0].avatar_path +
                                    "/" +
                                    user.UserPetstores[0].avatar_file_name
                                  }
                                  alt=""
                                />
                              ) : user.UserPetstores[0].gender === "male" ? (
                                <img
                                  src="../assets/app/media/img/users/men_sample.png"
                                  alt=""
                                />
                              ) : (
                                <img
                                  src="../assets/app/media/img/users/women_sample.png"
                                  alt=""
                                />
                              )}
                            </div>
                            <div className="m-widget4__info mx-auto my-0 mt-2 col-sm-12">
                              {this.state.changeAvatar ? (
                                <div className="form-group m-form__group row">
                                  {/* <label className="col-lg-4 col-form-label">Select Image</label> */}
                                  <div className="col-lg-12">
                                    <input
                                      ref="file"
                                      type="file"
                                      accept="image/*"
                                      name="imgName"
                                      onChange={this._onChange}
                                    />
                                  </div>
                                </div>
                              ) : (
                                <button
                                  type="button"
                                  onClick={() => this.changeAvatar()}
                                  className="btn btn-link btn-link-no-deco"
                                  style={{ width: "unset" }}
                                >
                                  <i className="la la-edit"></i>
                                </button>
                              )}
                            </div>
                            {this.state.imgSrc && this.state.changeAvatar && (
                              <div className="m-widget4__info mx-auto my-0 mt-2 col-sm-12">
                                <button
                                  onClick={this.saveAvatar}
                                  type="button"
                                  className="btn m-btn--pill btn-outline-primary"
                                >
                                  <i className="fas fa-cloud-upload-alt"></i> Upload
                                </button>
                              </div>
                            )}
                          </div>
                          <div className="row">
                            <div className="m-widget4__info mx-auto my-0 mt-2 mb-4">
                              <span className="m-widget4__title">
                                {!edit
                                  ? user.UserPetstores[0].Role.role_name
                                  : role}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      {cPassword ? (
                        <React.Fragment>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <strong>Current Password: </strong>
                                </span>
                                <input
                                  type="password"
                                  name="currentPw"
                                  value={currentPw}
                                  onChange={this.changeVal}
                                  className="form-control m-input"
                                  placeholder=""
                                />
                              </div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <strong>New Password: </strong>
                                </span>
                                <input
                                  type="password"
                                  name="newPw"
                                  value={newPw}
                                  onChange={this.changeVal}
                                  className="form-control m-input"
                                  placeholder=""
                                />
                              </div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <strong>Retype New Password: </strong>
                                </span>
                                <input
                                  type="password"
                                  name="retypePw"
                                  value={retypePw}
                                  onChange={this.changeVal}
                                  className="form-control m-input"
                                  placeholder=""
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-12">
                              {!this.state.loading && (
                                <div className="m-widget4__action m--align-right">
                                  <button
                                    onClick={this.saveCPassword}
                                    type="button"
                                    className="btn m-btn--pill btn-outline-primary"
                                  >
                                    Save
                                  </button>
                                </div>
                              )}
                              {this.state.loading && (
                                <div className="center-row">
                                  <Loader size={50} />
                                </div>
                              )}
                            </div>
                          </div>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-at mr-2"></i>
                                  <strong>Email: </strong>
                                  <a href={`mailto:${user.email}?body=Hello, ${toCapitalize(user.UserPetstores[0].firstname)}!`} className="hyperlink">
                                    {user.email}
                                  </a>
                                </span>
                              </div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-at mr-2"></i>
                                  <strong>Username: </strong>
                                  {user.username}
                                </span>
                              </div>
                              {edit && (
                                <React.Fragment>
                                  <div className="m-widget4__item">
                                    <span className="m-widget4__sub">
                                      <i className="fas fa-tag mr-2"></i>
                                      <span>
                                        <strong>First Name: </strong>
                                      </span>
                                    </span>
                                    <input
                                      type="text"
                                      name="firstname"
                                      value={firstname}
                                      onChange={this.changeVal}
                                      className="form-control m-input"
                                      placeholder=""
                                    />
                                  </div>

                                  {this.state.loading && (
                                    <div className="center-row">
                                      <Loader size={50} />
                                    </div>
                                  )}
                                  {this.props.data.currentUser.UserPetstores[0]
                                    .Role.role_name === "Admin" && (
                                    <div className="m-widget4__item">
                                      <span className="m-widget4__sub">
                                        <i className="fas fa-fingerprint mr-2"></i>
                                        <span>
                                          <strong>Employee Id: </strong>
                                        </span>
                                      </span>
                                      <input
                                        type="text"
                                        name="employee_id"
                                        value={employee_id}
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                      />
                                    </div>
                                  )}
                                </React.Fragment>
                              )}
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-genderless mr-2"></i>
                                  <span>
                                    <strong>Gender: </strong>
                                  </span>
                                </span>
                                {!edit ? (
                                  user.UserPetstores[0].gender
                                ) : (
                                  <select
                                    name="gender"
                                    onChange={this.changeVal}
                                    className="form-control m-input"
                                    placeholder=""
                                    value={gender}
                                  >
                                    <option value="male">Male</option>
                                    <option value="female">Female</option>
                                  </select>
                                )}
                              </div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-birthday-cake mr-2"></i>
                                  <span>
                                    <strong>Birthday: </strong>
                                  </span>
                                </span>
                                {!edit ? (
                                  user.UserPetstores[0].birthday
                                ) : (
                                  <DatePicker
                                    selected={birthday}
                                    value={birthday}
                                    onChange={this.changeDate}
                                    onSelect={this.changeDate}
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    className="form-control"
                                  />
                                )}
                              </div>
                              <div className="m-widget4__item item-last">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-phone-square mr-2"></i>
                                  <strong>Contact No: </strong>
                                </span>
                                {!edit ? (
                                  <a href={`tel:${user.UserPetstores[0].contact_no}`} className="hyperlink-phone-number">
                                    {user.UserPetstores[0].contact_no}
                                  </a>
                                ) : (
                                  <PhoneInput
                                    country={country}
                                    className="form-control"
                                    placeholder="Enter phone number"
                                    value={contact_no}
                                    onChange={value =>
                                      this.setState({ contact_no: value })
                                    }
                                  />
                                )}
                              </div>
                              {edit && role === "Admin" && (
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-users mr-2"></i>
                                    <span>
                                      <strong>Role: </strong>
                                    </span>
                                  </span>
                                  <select
                                    name="role"
                                    onChange={this.changeVal}
                                    className="form-control m-input"
                                    placeholder=""
                                    value={role}
                                  >
                                    <option value="Admin">Admin</option>
                                    <option value="Caretaker">Caretaker</option>
                                    <option value="Cashier">Cashier</option>
                                  </select>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-12">
                              {edit && !this.state.loading && (
                                <div className="m-widget4__action m--align-right">
                                  <button
                                    onClick={() => this.cancelEdit()}
                                    type="button"
                                    className="btn m-btn--pill btn-secondary mr-2"
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    onClick={this.saveUser}
                                    type="button"
                                    className="btn m-btn--pill btn-outline-primary"
                                  >
                                    Save
                                  </button>
                                </div>
                              )}
                              {edit && this.state.loading && (
                                <div className="center-row">
                                  <Loader size={50} />
                                </div>
                              )}
                            </div>
                          </div>
                        </React.Fragment>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.cognito.user,
  userPool: state.cognito.userPool,
  config: state.cognito.config,
  cognitoState: state.cognito.state,
  data: state.userReducer,
  petShop: state.petShopReducer
});

const mapDispatchToProps = dispatch => ({
  fetchUser: id => {
    dispatch(fetchUser(id));
  },
  updateUser: (id, data) => {
    dispatch(updateUser(id, data));
  },
  attachAvatar: (id, avatar) => {
    dispatch(attachAvatar(id, avatar));
  }
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Profile)
);
